import { Modal } from 'bootstrap';

//
// Initialize variables
//

let modalVideoYouTube = document.getElementById('modal-video-youtube'),
    modalVideoVimeo = document.getElementById('modal-video-vimeo'),
    modalHintYouTube = document.getElementById('modal-hint-youtube'),
    modalHintVimeo = document.getElementById('modal-hint-vimeo');


//
// Functions
//

function getYouTubeVideoId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
}


//
// Initialize functions
//

function replaceHintModalValues(modalButton) {

    let button = modalButton.relatedTarget, // Button that triggered the modal
        privacy = button.getAttribute('data-bs-privacy'),
        cookie = button.getAttribute('data-bs-cookie'),
        video = button.getAttribute('data-bs-video'),
        videoTitle = button.getAttribute('data-bs-video-title');


    // If necessary, you could initiate an AJAX request here
    // and then do the updating in a callback.
    //
    // Update the modal's content.
    let privacyObj = modalHintYouTube.querySelector('[data-bs-replace-privacy]'),
        cookieObj = modalHintYouTube.querySelector('[data-bs-replace-cookie]'),
        videoObj = modalHintYouTube.querySelector('[data-bs-video]'),
        videoTitleObj = modalHintYouTube.querySelector('[data-bs-video-title]');

    if (privacyObj) {
      privacyObj.href = privacy;
    }
    if (cookieObj) {
      cookieObj.href = cookie;
    }
    videoObj.setAttribute('data-bs-video', video);
    videoTitleObj.setAttribute('data-bs-video-title', videoTitle);
}

function replaceVideoYouTubeModalValues(modalButton) {
    let button = modalButton.relatedTarget, // Button that triggered the modal
        videoSrc = button.getAttribute('data-bs-video'),
        videoId = getYouTubeVideoId(videoSrc),
        videoTitle = button.getAttribute('data-bs-video-title');

    let videoSrcObj = modalVideoYouTube.querySelector('[data-bs-replace-video-src]'),
        videoTitleObj = modalVideoYouTube.querySelector('[data-bs-replace-video-title]');

    //videoSrcObj.src = "https://www.youtube.com/embed/${videoSrc}";
    videoSrcObj.src = 'https://www.youtube-nocookie.com/embed/' + videoId;
    videoTitleObj.innerHTML = videoTitle;
}


//
// Video modal show
// Fix error where the second modal in a chain is not adding model-open class to body
//

modalVideoYouTube.addEventListener('show.bs.modal', function (event) {
    // document.body.classList.add('modal-open-second');
    replaceVideoYouTubeModalValues(event);

  const modal = Modal.getInstance(modalHintYouTube);
  modal.hide();
});
modalVideoVimeo.addEventListener('show.bs.modal', function (event) {
    // document.body.classList.add('modal-open-second');
    // replaceVideoVimeoModalValues(event);

  const modal = Modal.getInstance(modalHintVimeo);
  modal.hide();
});




//
// Empty iframe, stops for example video sounds in background
//

modalVideoYouTube.addEventListener('hidden.bs.modal', function () {
    // document.body.classList.remove('modal-open-second');
    let iframe = modalVideoYouTube.querySelector('iframe');
    if (iframe) {
        iframe.src = '';
    }
});

modalVideoVimeo.addEventListener('hidden.bs.modal', function () {
    // document.body.classList.remove('modal-open-second');
    let iframe = modalVideoVimeo.querySelector('iframe');
    if (iframe) {
        iframe.src = '';
    }
});

modalHintYouTube.addEventListener('show.bs.modal', function (event) {
    replaceHintModalValues(event);
    //alert('modalHintYouTube - show.bs.modal');
});

modalHintVimeo.addEventListener('show.bs.modal', function (event) {
    replaceHintModalValues(event);
});
